import React from 'react'
import Autosuggest from 'react-autosuggest'
import {Input} from '../InputStyles'
import {AutosuggestView} from './AutosuggestStyles'

const getSuggestionValue = suggestion => suggestion.value

const renderInputComponent = ({
  onSuggestionSelected,
  onSuggestionsFetchRequested,
  onSuggestionsClearRequested,
  ...inputProps
}) => (
  <div>
    <Input {...inputProps} ref={inputProps.ref} />
  </div>
)

class AutoSuggestInput extends React.Component {
  onChange = (event, {newValue}) => {
    this.props.onChange({target: {value: newValue, name: this.props.name}})
  }

  // select value when press Tab button on highlighted option
  onBlur = (event, {highlightedSuggestion}) => {
    if (highlightedSuggestion && this.props.onSuggestionSelected) {
      this.props.onSuggestionSelected(event, {suggestion: highlightedSuggestion})
      this.props.onChange({target: {value: highlightedSuggestion.value, name: this.props.name}})
    }
  }

  render() {
    return (
      <AutosuggestView>
        <Autosuggest
          suggestions={this.props.suggestions}
          onSuggestionsFetchRequested={this.props.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.props.onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={this.props.renderSuggestion}
          renderInputComponent={renderInputComponent}
          onSuggestionSelected={this.props.onSuggestionSelected}
          inputProps={{...this.props, onChange: this.onChange, onBlur: this.onBlur}}
        />
      </AutosuggestView>
    )
  }
}

export default AutoSuggestInput
